import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Seo from '../common/Seo';

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }
    
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post('https://www.sportyreplay.de/api/auth/reset-password.php', {
        token,
        password
      }, { withCredentials: true });

      setMessage(response.data.message);
      
      // Nach erfolgreicher Passwortänderung zur Login-Seite navigieren
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ein Fehler ist aufgetreten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center pt-16">
      <Seo title="Passwort zuruecksetzen | SportyReplay" noindex />
      <div className="text-3xl font-bold mb-8">
        <span className="text-white">Sporty</span>
        <span className="text-orange-500">Replay</span>
      </div>
      
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Neues Passwort festlegen</h2>
        
        {message && (
          <div className="mb-4 p-2 bg-green-100 border border-green-400 text-green-700 rounded">
            {message}
          </div>
        )}
        
        {error && (
          <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="password">
              Neues Passwort
            </label>
            <input
              type="password"
              id="password"
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 mb-2" htmlFor="confirmPassword">
              Passwort bestätigen
            </label>
            <input
              type="password"
              id="confirmPassword"
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          
          <button
            type="submit"
            className="w-full bg-orange-500 text-white py-3 px-4 rounded hover:bg-orange-600 transition duration-200"
            disabled={loading}
          >
            {loading ? 'Wird aktualisiert...' : 'Passwort aktualisieren'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;